import { KeyRound } from 'lucide-react';
import { DeckardIconWrapper, type DeckardIcon } from './DeckardIcon';

export const SecretIcon: DeckardIcon = DeckardIconWrapper({ Icon: KeyRound });
